
import { NgModule } from '@angular/core';
import { PAGES_ROUTES } from './pages.routes';

import { SharedModule } from '../shared/shared.module';

//
import { MantContModule } from '../pages/mantenimientocontributors/mantenimientocontributors.module';
import { ContribuyenteFundersModule } from './funders/funders/contribuyentefunders.module';
//

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';

import { InputTextareaModule } from 'primeng/inputtextarea';

import { MultiSelectModule } from 'primeng/multiselect';

import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DialogModule, Dialog } from 'primeng/dialog';
import { CheckboxModule } from 'primeng/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule, MatNativeDateModule, 
         MatRadioModule, MatSelectModule, MatExpansionModule, 
         MatTabsModule } from '@angular/material';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';


import {AutoCompleteModule} from 'primeng/autocomplete';

// ng2-charts
import { ChartsModule } from 'ng2-charts';
import { ChartModule } from 'primeng/chart';

// [13/08/2026] Se retiraron @angular/fire (AngularFireModule, AngularFireStorageModule) y el import de environment:
// El proyecto sólo usa Firebase Hosting (archivos estáticos). Ningún servicio inyecta AngularFirestore/Auth/Storage,
// por lo que el SDK de Firebase era peso muerto en el bundle.

import { FileUploadModule } from 'primeng/fileupload';

import { PagesComponent } from './pages.component';

import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProgressComponent } from './progress/progress.component';
import { Graficas1Component } from './graficas1/graficas1.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { CommonModule } from '@angular/common';
import { PickListModule } from 'primeng/picklist';
import { IncrementadorComponent } from '../components/incrementador/incrementador.component';
import { GraficoDonaComponent } from '../components/grafico-dona/grafico-dona.component';
import { AccoutSettingsComponent } from './accout-settings/accout-settings.component';
import { RxjsComponent } from './rxjs/rxjs.component';
import { CrearUsuarioComponent } from './usuarios/crearusuario.component';
import { VerUsuariosComponent } from './usuarios/verusuarios.component';
import { EditarUsuarioComponent } from './usuarios/editarusuario.component';
import { DataTablesModule } from 'angular-datatables';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PipesModule } from '../pipes/pipes.module';
import { PrivilegiosUsuariosComponent } from './privilegiosusuarios/privilegiosusuarios.component';
import { PrivilegioUsuarioComponent } from './privilegiosusuarios/privilegiousuario.component';
import { CrearPrivilegioComponent } from './privilegiosusuarios/crearprivilegio.component';
import { ActualizaPrivilegioComponent } from './privilegiosusuarios/actualizaprivilegio.component';
import { RolesComponent } from './roles/roles.component';
import { CrearRolComponent } from './roles/crearrol.component';
import { ActualizaRolComponent } from './roles/actualizarol.component';
import { ParametrosComponent } from './parametrosgenerales/parametros.component';
import { CreaParametroComponent } from './parametrosgenerales/creaparametro.component';
import { ActualizaParametroComponent } from './parametrosgenerales/actualizaparametro.component';
import { OptionsComponent } from './options/options.component';
import { CreaOptionComponent } from './options/creaoption.component';
import { ActualizaOptionComponent } from './options/actualizaoption.component';
import { AsignaOptionsComponent } from './userOptions/asignaoptions.component';
import { UsuariosOptionsComponent } from './userOptions/usuariosoptions.component';
import { ListasComponent } from './listas/listas.component';
import { CreaListaComponent } from './listas/crealista.component';
import { RolesOptionsComponent } from './roleOptions/rolesoptions.component';
import { AsignaOptionsRolesComponent } from './roleOptions/asignaoptionsroles.component';
import { ActualizaListaComponent } from './listas/actualizalista.component';
import { AltacontribuyentesComponent } from './altacontribuyentes/altacontribuyentes.component';
import { StpAccountsComponent } from './stpaccounts/stpaccounts.component';
import { MantcontribuyentesComponent } from './mantenimientocontribuyentes/mantcontribuyentes.component';
import { AltaSolicitudesComponent } from './alta solicitudes/altasolicitudes.component';
import { EstatusSolicitudesComponent } from './estatussolicitudes/estatussolicitudes.component';
import { FacturasComponent } from './reportes/facturas.component';
import { DailyoperationsComponent } from './reportes/dailyoperations.component';
import { LayoutBanorteComponent } from './reportes/layoutbanorte.component';
import { PagosCompanyComponent } from './reportes/pagoscompany.component';
import { AproveedorComponent } from './pagos/aproveedor.component';
import { DeCadenaComponent } from './pagos/decadena.component';
import { FacturasDetallesComponent } from './reportes/facturasdetalles.component';
import { FacturaDetalleComponent } from './reportes/facturadetalle.component';
import { ReporteSolicitudesComponent } from './reportes/reportesolicitudes.component';
import { ReporteSolicitudesDetallesComponent } from './reportes/reportesolicitudesdetalles.component';
import { ReporteSolicitudDetalleComponent } from './reportes/reportesolicituddetalle.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { ActualizaTarifaComponent } from './tarifas/actualizatarifa.component';
import { CreaTarifaComponent } from './tarifas/creatarifa.component';
import { AltaCyPComponent } from './altacyp/altacyp.component';
import { ActualizaCadenaComponent } from './altacyp/actualizacadena.component';
import { CreaCadenaComponent } from './altacyp/creacadena.component';
import { CreaProveedorComponent } from './altacyp/creaproveedor.component';
import { ActualizaProveedorComponent } from './altacyp/actualizaproveedor.component';
import { AltaFacturasComponent } from './facturas/altafacturas.component';
import { MantenimientoContComponent } from './mantenimientocontribuyentes/mantenimientocont.component';
import { ContribuyenteMantComponent } from './mantenimientocontribuyentes/contribuyentemant.component';
import { CfdisComponent } from './reportes/cfdis.component';
import { PaymentCfdisComponent } from './reportes/payment_cfdis.component';
import { UsuariosProveedoresComponent } from './userSupliers/usuariosproveedores.component';
import { AsignarProveedorComponent } from './userSupliers/asignarproveedor.component';
import { DirectorReportComponent } from './reportes/directorreport.component';
import { SegmentosCadenaComponent } from './altacyp/segmentoscadena.component';
import { SuplierProjectsComponent } from './suplierproject/suplierprojects.component';
import { MuestraSuplierProjectsComponent } from './suplierproject/muestrasuplierprojects.component';
import { UsuariosCadenasComponent } from './userCompany/usuarioscadenas.component';
import { AsignarCadenaComponent } from './userCompany/asignarcadena.component';
import { BancosComponent } from './reportes/bancos/bancos.component';
import { BanorteComponent } from './reportes/bancos/banorte.component';
import { MonexComponent } from './reportes/bancos/monex.component';
import { StpComponent } from './reportes/bancos/stp.component';
import { BanregioComponent } from './reportes/bancos/banregio.component';
import { BaseComponent } from './reportes/bancos/base.component';
import { BancreaComponent } from './reportes/bancos/bancrea.component';
import { CesionderechosComponent } from './cesionderechos/cesionderechos.component';
import { ContribuyentesfundersComponent } from './funders/funder/contribuyentesfunders.component';
import { CreaFunderComponent } from './funders/funder/creafunder.component';
import { ActualizaFunderComponent } from './funders/funder/actualizafunder.component';
import { CreaCreditlineComponent } from './funders/creditline/creacreditline.component';
import { SolicitudDeFondeoComponent } from './funders/solicituddefondeo/solicituddefondeo.component';
import { AfinancieraComponent } from './funders/pagos/afinanciera.component';
import { AfondeadorComponent } from './funders/pagos/afondeador.component';
import { ReporteSolicitudesFondeoComponent } from './reportes/reportesolicitudesfondeo.component';
import { CreaSegmentoCadenaComponent } from './altacyp/creasegmentocadena.component';
import { EditaSegmentoCadenaComponent } from './altacyp/editasegmentocadena.component';
import { ClientesCadenaComponent } from './altacyp/clientesscadena.component';
import { EditaClienteCadenaComponent } from './altacyp/editaclientecadena.component';
import { CuentasContablesComponent } from './contabilidad/cuentascontables/cuentascontables.component';
import { CreaCuentaContableComponent } from './contabilidad/cuentascontables/creacuentacontable.component';
import { ActualizaCuentaContableComponent } from './contabilidad/cuentascontables/actualizacuentacontable.component';
import { GeneraPolizaComponent } from './contabilidad/generapoliza/generapoliza.component';
import { ConsultaPolizaComponent } from './contabilidad/consultapoliza/consultapoliza.component';
import { CobranzaDirectaComponent } from './funders/cobranzadirecta/cobranzadirecta.component';
import { RegfactcopachisaComponent } from './regfactcopachisa/regfactcopachisa.component';
import { AltafacturasddComponent } from './altafacturasdd/altafacturasdd.component';
import { AltafacturasddNcComponent } from './altafactudd/altafacturasddnc.component'
import { CapturaFacturasComponent } from './captura-facturas/captura-facturas.component';
import { RevisionFacturasComponent } from './revision-facturas/revision-facturas.component';
import { AltafactlayoutComponent } from './altafactlayout/altafactlayout.component';
import { EstadoCuentaCadenaComponent } from './reportes/estado-cuenta-cadena/estado-cuenta-cadena.component';
import { DispersionStpComponent } from './reportes/bancos/dispersion-stp.component';
import { TraspasosStpComponent } from './reportes/bancos/traspasos-stp.component';
import { SaldosStpComponent } from './reportes/bancos/saldos-stp.component';
import { ConciliacionComponent } from './reportes/conciliacion/conciliacion.component';
import { AfiliacionComponent } from './afiliacion/afiliacion.component';
import { AfiliacionAltComponent } from './afiliacionalt/afiliacionalt.component'
import { EstadoCuentaContribuyenteComponent } from './estado-cuenta-contribuyente/estado-cuenta-contribuyente.component';
import { SeguimientoPendientesComponent } from './reportes/seguimiento-pendientes/seguimiento-pendientes.component';
import { FacturasOperadasComponent } from './reportes/facturas-operadas/facturas-operadas.component';
import { BbvaComponent } from './reportes/bancos/bbva.component';
import { RevisionFacturasFinantahComponent } from './revision-facturas-finantah/revision-facturas-finantah.component';
import { MantenimientoAfiliacionComponent } from './afiliacion/mantenimiento-afiliacion/mantenimiento-afiliacion.component';
import { MantenimientoProveedorComponent } from './afiliacion/mantenimiento-afiliacion/mantenimiento-proveedor/mantenimiento-proveedor.component';
import { AyudaComponent } from './ayuda/ayuda.component';
import { RevisionFacturasSatComponent } from './revision-facturas-sat/revision-facturas-sat.component';
import { FunderTagsComponent } from './funders/funder-tags/funder-tags.component';
import { FunderValuesComponent } from './funders/funder-tags/funder-values/funder-values.component';
import { ListaFunderTagsComponent } from './funders/funder-tags/lista-funder-tags.component';
import { FacturasaltComponent } from './reportes/facturasalt.component';
// FUNDER DASHBOARD - START
import { VerFunderUsersComponent } from './funderusers/verfunderusers.component';
import { CrearFunderUserComponent } from './funderusers/crearfunderuser.component';
// FUNDER DASHBOARD - END
// MESA DE CONTROL - START
import { DashboardMesaControlComponent } from './mesa-control/mesa-control.component';
// MESA DE CONTROL - END
// FACTURACION MASIVA - START
import { FacturacionMasivaComponent } from './facturacion-masiva/facturacion-masiva.component';
import { DetalleLoteComponent } from './facturacion-masiva/detalle-lote/detalle-lote.component';
// FACTURACION MASIVA - END
// Panel de progreso de pagos asincrónicos
import { PaymentProgressPanelComponent } from './pagos/payment-progress-panel/payment-progress-panel.component';
// PAGO RESERVA - START - 01/10/2026
import { PagoReservaComponent } from './pagos/pago-reserva/pago-reserva.component';
// PAGO RESERVA - END
// PAGO UNIFICADO - START - 01/10/2026
import { PagoUnificadoComponent } from './pagos/pago-unificado/pago-unificado.component';
// PAGO UNIFICADO - END
@NgModule({
    declarations: [
        PagesComponent,
        DashboardComponent,
        ProgressComponent,
        Graficas1Component,
        IncrementadorComponent,
        GraficoDonaComponent,
        AccoutSettingsComponent,
        RxjsComponent,
        CrearUsuarioComponent,
        VerUsuariosComponent,
        EditarUsuarioComponent,
        PrivilegiosUsuariosComponent,
        PrivilegioUsuarioComponent,
        CrearPrivilegioComponent,
        ActualizaPrivilegioComponent,
        RolesComponent,
        CrearRolComponent,
        ActualizaRolComponent,
        ParametrosComponent,
        CreaParametroComponent,
        ActualizaParametroComponent,
        OptionsComponent,
        CreaOptionComponent,
        ActualizaOptionComponent,
        AsignaOptionsComponent,
        UsuariosOptionsComponent,
        ListasComponent,
        CreaListaComponent,
        RolesOptionsComponent,
        AsignaOptionsRolesComponent,
        ActualizaListaComponent,
        AltacontribuyentesComponent,
        StpAccountsComponent,
        MantcontribuyentesComponent,
        AltaSolicitudesComponent,
        EstatusSolicitudesComponent,
        FacturasComponent,
        DailyoperationsComponent,
        LayoutBanorteComponent,
        PagosCompanyComponent,
        AproveedorComponent,
        DeCadenaComponent,
        FacturasDetallesComponent,
        FacturaDetalleComponent,
        ReporteSolicitudesComponent,
        ReporteSolicitudesDetallesComponent,
        ReporteSolicitudDetalleComponent,
        TarifasComponent,
        ActualizaTarifaComponent,
        CreaTarifaComponent,
        AltaCyPComponent,
        ActualizaCadenaComponent,
        ActualizaProveedorComponent,
        CreaCadenaComponent,
        CreaProveedorComponent,
        AltaFacturasComponent,
        MantenimientoContComponent,
        ContribuyenteMantComponent,
        CfdisComponent,
        PaymentCfdisComponent,
        UsuariosProveedoresComponent,
        AsignarProveedorComponent,
        UsuariosCadenasComponent,
        AsignarCadenaComponent,
        DirectorReportComponent,
        SegmentosCadenaComponent,
        CreaSegmentoCadenaComponent,
        EditaSegmentoCadenaComponent,
        SuplierProjectsComponent,
        MuestraSuplierProjectsComponent,
        BancosComponent,
        BanorteComponent,
        MonexComponent,
        StpComponent,
        BanregioComponent,
        BaseComponent,
        BancreaComponent,
        CesionderechosComponent,
        ContribuyentesfundersComponent,
        CreaFunderComponent,
        ActualizaFunderComponent,
        CreaCreditlineComponent,
        SolicitudDeFondeoComponent,
        AfinancieraComponent,
        AfondeadorComponent,
        ReporteSolicitudesFondeoComponent,
        ClientesCadenaComponent,
        EditaClienteCadenaComponent,
        CuentasContablesComponent,
        CreaCuentaContableComponent,
        ActualizaCuentaContableComponent,
        GeneraPolizaComponent,
        ConsultaPolizaComponent,
        CobranzaDirectaComponent,
        RegfactcopachisaComponent,
        AltafacturasddComponent,
        AltafacturasddNcComponent,
        CapturaFacturasComponent,
        RevisionFacturasComponent,
        AltafactlayoutComponent,
        EstadoCuentaCadenaComponent,
        DispersionStpComponent,
        TraspasosStpComponent,
        SaldosStpComponent,
        ConciliacionComponent,
        AfiliacionComponent,
        AfiliacionAltComponent,
        EstadoCuentaContribuyenteComponent,
        SeguimientoPendientesComponent,
        FacturasOperadasComponent,
        BbvaComponent,
        RevisionFacturasFinantahComponent,
        MantenimientoAfiliacionComponent,
        MantenimientoProveedorComponent,
        AyudaComponent,
        RevisionFacturasSatComponent,
        FunderTagsComponent,
        FunderValuesComponent,
        ListaFunderTagsComponent,
        FacturasaltComponent,
        // FUNDER DASHBOARD - START
        VerFunderUsersComponent,
        CrearFunderUserComponent,
        // FUNDER DASHBOARD - END
        // MESA DE CONTROL - START
        DashboardMesaControlComponent,
        // MESA DE CONTROL - END
        // FACTURACION MASIVA - START
        FacturacionMasivaComponent,
        DetalleLoteComponent,
        // FACTURACION MASIVA - END
        // Panel de progreso de pagos asincrónicos
        PaymentProgressPanelComponent,
        // PAGO RESERVA - START - 01/10/2026
        PagoReservaComponent,
        // PAGO RESERVA - END
        // PAGO UNIFICADO - START - 01/10/2026
        PagoUnificadoComponent
        // PAGO UNIFICADO - END
    ],
    exports: [
        DashboardComponent,
        ProgressComponent,
        Graficas1Component
    ],
    imports: [
        MantContModule,
        ContribuyenteFundersModule,
        DropdownModule,
        SharedModule,
        PAGES_ROUTES,
        FormsModule,
        ReactiveFormsModule,
        ChartsModule,
        PipesModule,
        CommonModule,
        TableModule,
        BrowserAnimationsModule,
        DataTablesModule,
        InputSwitchModule,
        PickListModule,
        BreadcrumbModule,
        MatSliderModule,
        MatStepperModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MultiSelectModule,
        InputTextareaModule,
        ChartModule,
        CheckboxModule,
        FileUploadModule,
        TabViewModule,
        DialogModule,
        // [13/08/2026] Se retiró AngularFireModule.initializeApp(environment.firebase): sólo cargaba el SDK de Firebase al bundle sin que ningún servicio inyectara AngularFirestore/AngularFireAuth/AngularFireStorage.
        MatProgressBarModule,
        MatCheckboxModule,
        AutoCompleteModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatRadioModule,
        MatSelectModule,
        MatExpansionModule,
        MatTabsModule
    ]
})
export class PagesModule { }
